// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.same-value.js
// module id = 600
// module chunks = 174 178 179 193 194